import { Star } from "@components/icons"
import breakpoints from "@constants/breakpoints"
import React, { useState } from "react"
import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const IconWrapper = styled.div`
  cursor: pointer;
`

const Icon = styled.div<{ $filled: boolean }>`
  width: 18.96px;
  height: 17.63px;
  margin-right: 4px;
  opacity: ${(props) => (props.$filled ? 1 : 0.3)};
  line-height: initial;

  @media ${breakpoints.laptop} {
    margin-right: 8px;
  }

  svg {
    vertical-align: initial;
  }
`

interface IProps {
  className?: string
  onChange(stars: number): void
  stars: number
}

const StarsInput = (props: IProps) => {
  const [hover, setHover] = useState(false)
  const [hoverIndex, setHoverIndex] = useState(0)

  const onMouseEnter = (index: number) => {
    setHoverIndex(index)
    setHover(true)
  }

  const onMouseLeave = () => {
    setHover(false)
    setHoverIndex(0)
  }

  return (
    <Container className={props.className}>
      {Array(5)
        .fill(null)
        .map((value, index) => (
          <IconWrapper
            key={index}
            onClick={() => props.onChange(index + 1)}
            onMouseEnter={() => onMouseEnter(index + 1)}
            onMouseLeave={() => onMouseLeave()}
          >
            <Icon $filled={hover ? index < hoverIndex : index < props.stars}>
              <Star />
            </Icon>
          </IconWrapper>
        ))}
    </Container>
  )
}

export default StarsInput
